// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cA_k","newExpiryDate":"styles_newExpiryDate__1eVXg","footer":"styles_footer__2Igdz"};